import { render, staticRenderFns } from "./servAppraiseManageTable.vue?vue&type=template&id=25b8bb10&scoped=true"
import script from "./servAppraiseManageTable.vue?vue&type=script&lang=js"
export * from "./servAppraiseManageTable.vue?vue&type=script&lang=js"
import style0 from "./servAppraiseManageTable.vue?vue&type=style&index=0&id=25b8bb10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b8bb10",
  null
  
)

export default component.exports